import React from 'react'
import BoardCommitteeDataListData from '../../features/BoardCommitteeManagement/BoardCommitteeDataList'

const BoardCommitteeList = () => {
    return (
        <div>
            <BoardCommitteeDataListData />
        </div>
    )
}

export default BoardCommitteeList
